// Template193: Bangkok - Día 2 Tarde (Wat Saket, Loha Prasat, Khao San)
// Idéntico a PageTarde.jsx de guia-bangkok. borderRadius: "12px".

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { useMapFullscreen } from "../../context/MapFullscreenContext";
import SabiasQue from "../SabiasQue";

const Template193 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const [mapLoaded, setMapLoaded] = useState(false);
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const tipText = page?.texts?.[2]?.content;
	const watSaketTitle = page?.texts?.[3]?.content;
	const watSaketBody = page?.texts?.[4]?.content;
	const lohaPrasatText = page?.texts?.[5]?.content;
	const khaosanTitle = page?.texts?.[6]?.content;
	const khaosanBody = page?.texts?.[7]?.content;

	const mapEmbedUrl = page?.data?.mapEmbedUrl;
	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const watSaketImage = getImageSrc("wat-saket");
	const khaosanImage = getImageSrc("khao-san-road");
	const stickerUrl = getCanvasImageUrl("sticker");
	const bichosUrl = getCanvasImageUrl("bichos");
	const logoImage = getCanvasImageUrl("logo");

	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `
			@keyframes template193-spin {
				0% { transform: rotate(0deg); }
				100% { transform: rotate(360deg); }
			}
		`;
		document.head.appendChild(style);
		return () => document.head.removeChild(style);
	}, []);

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	if (fullscreen && mapEmbedUrl) {
		return (
			<Box
				sx={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Box
					sx={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: actualHeaderColor,
					}}
				>
					<Box
						component="button"
						onClick={() => setFullscreen(false)}
						sx={{
							backgroundColor: "#fff",
							color: actualHeaderColor,
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
						}}
					>
						← Volver a la guía
					</Box>
				</Box>
				<Box
					component="iframe"
					title="Mapa grande Día 2 Tarde"
					src={mapEmbedUrl}
					width="100%"
					sx={{ border: 0, flex: 1 }}
					allowFullScreen
					loading="lazy"
				/>
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="map" sx={{ flex: 1, marginTop: "-70px", position: "relative" }}>
				{mapEmbedUrl && !mapLoaded && (
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							height: 400,
							color: "black",
							fontSize: 14,
							position: "absolute",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								width: 20,
								height: 20,
								border: "4px solid #ccc",
								borderTop: "4px solid #E8A838",
								borderRadius: "50%",
								animation: "template193-spin 1s linear infinite",
							}}
						/>
					</Box>
				)}

				{mapEmbedUrl ? (
					<>
						<Box
							component="button"
							onClick={() => setFullscreen(true)}
							sx={{
								position: "absolute",
								top: 80,
								right: 10,
								backgroundColor: actualHeaderColor,
								color: "#fff",
								padding: "8px 10px",
								fontSize: "11px",
								borderRadius: "8px",
								boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
								zIndex: 4,
								border: "none",
								cursor: "pointer",
							}}
						>
							Ver mapa grande
						</Box>
						<Box
							component="iframe"
							title="Mapa Día 2 Tarde"
							src={mapEmbedUrl}
							width="100%"
							height="400px"
							loading="lazy"
							sx={{ border: 0 }}
							onLoad={() => setMapLoaded(true)}
						/>
					</>
				) : (
					<Box
						sx={{
							width: "100%",
							height: 400,
							backgroundColor: "#f0f0f0",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize: "13px",
							color: "#666",
							padding: 2.5,
							textAlign: "center",
						}}
					>
						Conecta a internet para ver el mapa de la zona.
					</Box>
				)}

				{tipText && (
					<Box
						sx={{
							position: "absolute",
							bottom: 80,
							right: 5,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 120,
							zIndex: 3,
						}}
					>
						{tipText}
					</Box>
				)}
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{
							width: 110,
							position: "absolute",
							bottom: 10,
							right: -10,
							zIndex: 2,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box component="p" sx={p}>
						{intro}
					</Box>
				)}
			</Box>

			<Box data-block-id="text-2" sx={{ padding: "0 12px" }}>
				<Box
					sx={{
						display: "flex",
						gap: 2,
						marginBottom: 1.75,
						position: "relative",
					}}
				>
					{sabiasQue.length > 0 && (
						<Box
							sx={{
								marginTop: 2,
								display: "flex",
								flexDirection: "column",
								gap: 1.5,
								position: "absolute",
								bottom: isSmallScreen ? 0 : 40,
								left: "30%",
								zIndex: 30,
							}}
						>
							<SabiasQue
								icono={sabiasQue[0]?.icono ?? "💡"}
								texto={sabiasQue[0]?.texto ?? ""}
							/>
							{sabiasQue[1] && (
								<SabiasQue
									icono={sabiasQue[1]?.icono ?? "💡"}
									texto={sabiasQue[1]?.texto ?? ""}
								/>
							)}
						</Box>
					)}
					{watSaketImage && (
						<Box
							component="img"
							src={watSaketImage}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								objectFit: "cover",
								borderRadius: "12px",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						<Box component="h3" sx={h3}>
							{watSaketTitle}
						</Box>
						{watSaketBody && (
							<Box component="p" sx={p}>
								{watSaketBody}
							</Box>
						)}
					</Box>
				</Box>

				{lohaPrasatText && (
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							gap: 2,
							padding: "0 12px",
							marginTop: 1,
							marginBottom: 1,
							position: "relative",
						}}
					>
						<Box sx={{ width: "100%" }}>
							<Box
								sx={{
									backgroundColor: "#FFF3CD",
									padding: 1.5,
									borderRadius: "12px",
								}}
							>
								<Box component="p" sx={p}>
									{lohaPrasatText}
								</Box>
							</Box>
						</Box>
					</Box>
				)}

				<Box
					data-block-id="text-4"
					sx={{
						display: "flex",
						gap: 2,
						marginBottom: 1.75,
						position: "relative",
					}}
				>
					{bichosUrl && (
						<Box
							component="img"
							src={bichosUrl}
							alt=""
							sx={{
								width: 110,
								position: "absolute",
								bottom: 10,
								left: -40,
								zIndex: 2,
							}}
						/>
					)}
					{khaosanImage && (
						<Box
							component="img"
							src={khaosanImage}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								objectFit: "cover",
								borderRadius: "12px",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						<Box component="h3" sx={h3}>
							{khaosanTitle}
						</Box>
						{khaosanBody && (
							<Box component="p" sx={p}>
								{khaosanBody}
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template193.thumbnail = "/images/template-1.png";
export default Template193;
